import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { faqData } from '../data/mock';
import { MessageCircle } from 'lucide-react';

const FAQ = () => {
  return (
    <section id="faq" className="py-24 bg-gradient-to-br from-gray-50 via-white to-orange-50/20">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-orange-500 rounded-2xl mb-6">
            <MessageCircle className="w-8 h-8 text-white" />
          </div>
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Frequently Asked
            <span className="text-orange-500"> Questions</span>
          </h2>
          <p className="text-xl text-gray-600">
            Everything you need to know about our services and process.
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="bg-white rounded-2xl shadow-xl p-8 border-2 border-gray-100">
          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq) => (
              <AccordionItem
                key={faq.id}
                value={faq.id}
                className="border-b border-gray-200 last:border-b-0"
              >
                <AccordionTrigger className="text-left text-lg font-semibold text-gray-900 hover:text-orange-500 transition-colors py-4">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-gray-600 leading-relaxed pb-4">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            Still have questions? We're here to help.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <button
              onClick={() => {
                const element = document.getElementById('contact');
                if (element) element.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-6 py-3 bg-orange-500 hover:bg-orange-600 text-white font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl"
            >
              Contact Us
            </button>
            <button
              onClick={() => window.open('mailto:kontakt@gr-prosperity.de')}
              className="px-6 py-3 border-2 border-gray-300 hover:border-orange-500 text-gray-700 hover:text-orange-500 font-semibold rounded-lg transition-all duration-300"
            >
              Send Email
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
